// extracted by mini-css-extract-plugin
module.exports = {"base":"JobQueue_base__1gfA5","centerVertically":"JobQueue_centerVertically__23p3b","centerHorizontally":"JobQueue_centerHorizontally__EzH-v","state":"JobQueue_state__6Kgmg"};